import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import styled from "@emotion/styled";
import { Divider } from "@mui/material";
import React, { useEffect, useState } from "react";
import { usePropertyDetail } from "store/property-detail";
import { useRouter } from "next/router";
import { useTranslations } from "next-intl";
import useDataLayerEvent from "custom-hooks/data-layer-event.hook";
import { UtmProperties } from "shared/models/const/utm-properties.const";
import { sentEvent } from "api/events/events.request";
import { PhoneMask } from "@components/mask-components";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import SendIcon from "@mui/icons-material/Send";
import { C_LEAD_TYPE } from "shared/models/enums/lead_type.enum";
import useLeadCountMutation from "custom-hooks/useLeadCountMutation";
import { I_LeadsCounterValues } from "api/clients/leads counter/leads.counter.request";
import { useDetailPropertyContextHook } from "@components-pages/propiedad/context/DetailPropertyContext";
import leadsCounterAdapter from "@endpoints/clients/lead counter/lead.counter.adapter";

interface CardAgentProps {
  handleMessageButton: (agent: any) => void;
  setExtraDataLayer: (data: any) => void;
}
function CardAgent(props: CardAgentProps) {
  const { propertyDetail } = useDetailPropertyContextHook();
  const { ADD_LEAD_COUNT_M } = useLeadCountMutation();
  const router = useRouter();
  const { property } = usePropertyDetail();
  const [agents, setAgents] = useState<any[]>([]);
  const translation = useTranslations("property");
  const { event } = useDataLayerEvent();

  useEffect(() => {
    if (router.query?.referer || router.query?.areferer) {
      setAgents(router.query?.referer ? property.agents : [property.agency]);
    } else {
      setAgents(property.agents);
    }
  }, [property]);

  if (agents?.length == 0) {
    return <></>;
  }

  const onPress = (
    typeEvent: "whatsapp" | "email" | "phone" | "msg",
    pos: number
  ) => {
    const Event = {
      event: "",
      body: {
        nombre_de_agente: router.query?.areferer ? null : agents[pos].name,
        nombre_de_agencia: router.query?.areferer
          ? agents[pos]?.name
          : agents[pos]?.agency_name,
        codigo_de_propiedad: property.id,
        ubicacion_propiedad: `${property.address} ${property.sector} ${property.city}`,
        sector: property.sector,
        ciudad: property.city,
        numero_del_agente:
          agents[pos].phone || agents[pos].mobile || agents[pos].phoneTwo,
        numero_del_agencia:
          agents[pos].phone || agents[pos].mobile || agents[pos].phoneTwo,
        numero_WhatsApp_del_agente:
          agents[pos].mobile || agents[pos].phone || agents[pos].phoneTwo,
        numero_WhatsApp_del_agencia:
          agents[pos].mobile || agents[pos].phone || agents[pos].phoneTwo,
        posicion: pos,
        codigo_de_referido: router.query?.areferer ?? router.query?.referer,
        correo: agents[pos].email,
        agency: router.query?.areferer
          ? agents[pos].name
          : agents[pos].agency_name,
        typeEvent: typeEvent,
        isAgency: router.query?.areferer ? true : false,
        propertyType: property.realstate_type,
        price_sale: property.price,
        price_rent: property.alternate_price,
      },
    };

    if (typeEvent == "whatsapp") {
      let url =
        process.env.NEXT_PUBLIC_DOMAIN_URL +
        router.asPath +
        `?${UtmProperties}`;

      ADD_LEAD_COUNT_M({
        ...leadsCounterAdapter({
          isReferred: propertyDetail.leadRefererInfo.isReferer,
          realestateId: propertyDetail.leadRefererInfo.propertyId,
          idSelected: agents[pos].id,
          isAgentReferer: propertyDetail.leadRefererInfo.isAgentReferer,
          isAgencyReferer: propertyDetail.leadRefererInfo.isAgenciesReferer,
          type: C_LEAD_TYPE.WHATSAPP,
        }),
      });

      event({
        event_name: "whatsapp_propiedad",
        body: Event.body,
      });

      sentEvent("whatsapp_contant_agent", agents[pos]?.id ?? -1).then(
        (response) => console.log(response)
      );
      window.open(
        `https://wa.me/1${
          agents[pos].mobile || agents[pos].phone || agents[pos].phoneTwo
        }?text=Me+interesa+conocer+acerca+de+esta+propiedad.%20${url}`,

        "_blank"
      );
      return;
    }

    // if (typeEvent == "email") {
    //   ADD_LEAD_COUNT_M({
    //     ...leadsCounterAdapter({
    //       isReferred: propertyDetail.leadRefererInfo.isReferer,
    //       realestateId: propertyDetail.leadRefererInfo.propertyId,
    //       idSelected: agents[pos].id,
    //       isAgentReferer: propertyDetail.leadRefererInfo.isAgentReferer,
    //       isAgencyReferer: propertyDetail.leadRefererInfo.isAgenciesReferer,
    //       type: C_LEAD_TYPE.MAIL,
    //     }),
    //   });

    //   event({
    //     event_name: router.query?.areferer
    //       ? "correo_agencia_propiedad"
    //       : "correo_agente_propiedad",
    //     body: Event.body,
    //   });
    //   return;
    // }

    if (typeEvent == "phone") {
      event({
        event_name: router.query?.areferer
          ? "phone_agencia_propiedad"
          : "phone_agente_propiedad",
        body: Event.body,
      });
      ADD_LEAD_COUNT_M({
        ...leadsCounterAdapter({
          isReferred: propertyDetail.leadRefererInfo.isReferer,
          realestateId: propertyDetail.leadRefererInfo.propertyId,
          idSelected: agents[pos].id,
          isAgentReferer: propertyDetail.leadRefererInfo.isAgentReferer,
          isAgencyReferer: propertyDetail.leadRefererInfo.isAgenciesReferer,
          type: C_LEAD_TYPE.CALL,
        }),
      });
      return;
    }

    if (typeEvent == "msg") {
      props.setExtraDataLayer(Event.body);
      props.handleMessageButton(agents[pos]);
    }
  };

  return (
    <>
      {agents?.map((agent: any, i) => (
        <ContentCard key={i}>
          <ContentImage>
            <img src={agent.picture} alt={agent.name} />
          </ContentImage>
          <Title>{agent.name}</Title>
          <Divider />
          <MessageContact>{translation("contact")}</MessageContact>
          <Divider />
          {/* WhatsApp Button*/}

          <BtnWhatsapp
            onClick={() => onPress("whatsapp", i)}
            style={{ marginBottom: "-10px" }}
          >
            <WhatsAppIcon />
            WhatsApp
            <PhoneMask
              value={agent.mobile || agent.phone || agent.phoneTwo}
              displayType="text"
            ></PhoneMask>
          </BtnWhatsapp>

          <InfoContact onClick={() => onPress("phone", i)}>
            <StyledLink
              href={`tel:${agent.mobile || agent.phone || agent.phoneTwo}`}
              style={{ marginTop: "-0px" }}
            >
              <BtnPhone>
                <LocalPhoneIcon sx={{ color: "white" }} />
                LLAMAR
                <PhoneMask
                  value={agent.mobile || agent.phone || agent.phoneTwo}
                  displayType="text"
                ></PhoneMask>
              </BtnPhone>
            </StyledLink>
          </InfoContact>

          {/* Mail Button*/}
          <BtnMail onClick={() => onPress("msg", i)}>
            <div>
              <SendIcon />
            </div>

            <div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                {translation("sendMessage")}
              </div>
              <TextInfo>{agent.email}</TextInfo>
            </div>
          </BtnMail>
        </ContentCard>
      ))}
    </>
  );
}

export default CardAgent;

const ContentCard = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  margin: 0px auto;
  margin-bottom: 25px;
`;

const ContentImage = styled.div`
  width: 100%;
  height: 200px;
  justify-content: center;
  align-items: center;
  display: flex;
  & img {
    width: 200px;
    height: 200px;
    margin: 0 auto;
    border-radius: 50%;
    object-fit: contain;
  }
`;

const Title = styled.h3`
  font-size: 1.5rem;
  font-weight: 600;
  color: black;
  margin: 10px auto;
`;

const MessageContact = styled.p`
  font-size: 0.9rem;
  font-weight: 500;
  color: black;
  margin: 10px auto;
`;

const TextInfo = styled.p`
  font-size: 12px;
  font-weight: 500;
  color: white;
`;

const InfoContact = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  margin-top: 10px;
  column-gap: 10px;

  & p {
    font-weight: 500;
    color: var(--color-brand-grey-secondary);
  }
`;

const sharestylebtn = `
    width: 100%;
    height: 45px;
    border-radius: 50px;
    border: none;
    outline: none;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    margin-top: 15px;
    font-weight: 500;
    font-size: 0.9rem;
    letter-spacing: 0.3px;
    transition: all 0.3s ease;
    font-family: var(--font-family);
    column-gap: 8px;
`;

const BtnWhatsapp = styled.button`
  ${sharestylebtn}
  background-color: var(--color-brand-green-main);
`;

const BtnPhone = styled.button`
  ${sharestylebtn}
  background-color: black;
`;

const BtnMail = styled.button`
  ${sharestylebtn}
  column-gap: 18px;
  flex-direction: row;
  height: 52px;
  background-color: var(--color-brand-blue-main);
`;

const StyledLink = styled.a`
  ${sharestylebtn}
  text-decoration: none;
`;
